import { useTranslation } from 'react-i18next';
import InvalidStopsWarningMessage from '../molecules/InvalidStopsWarningMessage';
import QuestionableStopsWarningMessage from '../molecules/QuestionableStopsWarningMessage';
import ConfirmDisableUnschedule from '../molecules/ConfirmDisableUnschedule';
import { useStore } from '../../../../store/mst';
import { observer } from 'mobx-react';

interface Props {
  invalidStopsCount: number,
  questionableStopsCount: number,
}

const SchedulingWarningModalContent: React.FC<Props> = ({ invalidStopsCount, questionableStopsCount }) => {
  const { t } = useTranslation('components');
  const { ui: { setDisableConfirmScheduleWarningModal } } = useStore();

  return (
    <>
      {
        invalidStopsCount > 0 && (
          <InvalidStopsWarningMessage
            message={t('unscheduledVisits.scheduleWarningModal.invalidOrder', { count: invalidStopsCount })}
            reason={t('unscheduledVisits.scheduleWarningModal.invalidOrderReason', { count: invalidStopsCount })}
          />
        )
      }
      {
        questionableStopsCount > 0 && (
          <QuestionableStopsWarningMessage
            message={t('unscheduledVisits.scheduleWarningModal.questionableOrder', { count: questionableStopsCount })}
            reason={t('unscheduledVisits.scheduleWarningModal.questionableOrderReason', { count: questionableStopsCount })}
          />
        )
      }
      <ConfirmDisableUnschedule onConfirm={setDisableConfirmScheduleWarningModal} />
    </>
  );
};

export default observer(SchedulingWarningModalContent);
